/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfProductReviewDto } from '../../models/paginated-dto-of-product-review-dto';

export interface FindProductReviews$Params {
  productId: number;
}

export function findProductReviews(http: HttpClient, rootUrl: string, params: FindProductReviews$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfProductReviewDto>> {
  const rb = new RequestBuilder(rootUrl, findProductReviews.PATH, 'get');
  if (params) {
    rb.query('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfProductReviewDto>;
    })
  );
}

findProductReviews.PATH = '/api/v1/product-reviews';
